import { ROUTES } from "config/routes";
import { ICONS_LABEL } from "shared/constants/icons";
import { AUTH_TEMP_USER } from "shared/constants/auth";

const manager = [
  {
    name: "Gerenciador de Arquivos",
    submenu: [
      {
        name: "Criar acesso temporário",
        url: ROUTES.USER_TEMP,
        icon: ICONS_LABEL.LockClockOutlined,
        notShow: localStorage.getItem(AUTH_TEMP_USER) === "1" ? true : false,
      },
      {
        name: "Meus Videos",
        url: ROUTES.VIDEOS,
        icon: ICONS_LABEL.CloudDoneOutlined,
      },
      {
        name: "Meus Arquivos",
        url: ROUTES.FILES,
        icon: ICONS_LABEL.AttachFileOutlined,
      },
      {
        name: "Relatórios",
        url: ROUTES.REPORTS,
        icon: ICONS_LABEL.AssessmentOutlined,
      },
      {
        name: "Downloads",
        url: ROUTES.DOWNLOADS,
        icon: ICONS_LABEL.CloudDownloadOutlined,
      },
      {
        name: "Registros",
        url: ROUTES.DOWNLOADS_LOGS,
        icon: ICONS_LABEL.TimelapseOutlined,
      },
      {
        name: "Navegação por pastas",
        url: ROUTES.FOLDER_NAVIGATION,
        icon: ICONS_LABEL.TimelapseOutlined,
      },
    ],
  },
  {
    name: "Administrativo",
    url: null,
    icon: ICONS_LABEL.AdminPanelSettings,
    submenu: [
      {
        name: "Acessos",
        url: ROUTES.ACCESS_LOGS,
        icon: ICONS_LABEL.TimelapseOutlined,
      },
    ],
  },
];

export default manager;
